{% block neti_incomplete_order_reminder_open_carts_list %}
    <sw-page class="neti-open-cart-list">
        <template #smart-bar-header>
            <h2>
                {{ $t('neti-incomplete-order-reminder.list.title') }}
                <span
                    v-if="!isLoading"
                    class="sw-page__smart-bar-amount"
                >
                    ({{ total }})
                </span>
            </h2>
        </template>

        <template #content>
            {% block neti_incomplete_order_reminder_open_carts_content %}
                <div class="neti-ior-cart-list__content">
                    <neti-ior-cart-listing
                        v-if="cartEntries"
                        :items="cartEntries"
                        :repository="repository"
                        :columns="columns"
                        :showSelection="false"
                        :isLoading="isLoading"
                        @column-sort="onColumnSort"
                        @page-change="onPageChange"
                        @update-records="onUpdateRecords"
                    >
                        <template #column-firstName="{ item }">
                            <router-link
                                v-if="item.firstName"
                                :to="{ name: 'sw.customer.detail', params: { id: item.customerId } }"
                            >
                                {{ item.firstName }}
                            </router-link>
                        </template>

                        <template #column-lastName="{ item }">
                            <router-link
                                v-if="item.lastName"
                                :to="{ name: 'sw.customer.detail', params: { id: item.customerId }}"
                            >
                                {{ item.lastName }}
                            </router-link>
                        </template>

                        <template #column-totalPrice="{ item }">
                            <a @click="showCartModal(item)">
                                {{ item.totalPrice }} {{ item.symbol }}
                            </a>
                        </template>

                        <template #column-mailed="{ item }">
                            <mt-icon
                                v-if="item.mailed"
                                name="regular-checkmark-xs"
                                size="16px"
                                class="is--active"
                            />

                            <mt-icon
                                v-else
                                name="regular-times-s"
                                size="16px"
                                class="is--inactive"
                            />
                        </template>

                        <template #column-createdAt="{ item }">
                            {{ dateFilter(item.createdAt, {hour: '2-digit', minute: '2-digit', second: '2-digit'}) }}
                        </template>

                        <template #actions="{ item }">
                            <sw-context-menu-item @click="showCartModal(item)">
                                {{ $t('neti-incomplete-order-reminder.list.contextMenuDetail') }}
                            </sw-context-menu-item>
                        </template>

                        <template #action-modals="{ item }">
                            <sw-modal
                                v-if="cartModalOpen === item.token"
                                @modal-close="onCloseCartModal"
                                :title="$t('neti-incomplete-order-reminder.list.modal.modalTitleDetail')"
                                class="neti--incompleteorderreminder--cart-details-modal"
                            >
                                <template
                                    v-if="detailCart"
                                    class="sw-order-detail-general__line-item-grid-card"
                                >
                                    <sw-data-grid
                                        class="sw-order-line-items-grid__data-grid"
                                        :data-source="detailCart.lineItems"
                                        :columns="cartItemColumns"
                                        :showSelection="false"
                                        :allowDelete="false"
                                        :is-loading="isLoading"
                                        :showActions="false"
                                    >
                                        <template
                                            #column-label="{ item, isInlineEdit }"
                                        >
                                            <div
                                                class="sw-order-line-items-grid__item-product"
                                            >
                                                <router-link
                                                    v-if="item.payload && item.payload.options"
                                                    class="sw-order-line-items-grid__item-payload-options"
                                                    :title="$t('sw-order.detailBase.contextMenuShowProduct')"
                                                    :to="{ name: 'sw.product.detail', params: { id: item.referencedId } }"
                                                >
                                                    <sw-product-variant-info
                                                        :variations="item.payload.options"
                                                    >
                                                        <div
                                                            class="sw-order-line-items-grid__item-label"
                                                        >
                                                            {{ item.label }}
                                                        </div>
                                                    </sw-product-variant-info>
                                                </router-link>

                                                <template
                                                    v-else
                                                    class="sw-order-line-items-grid__item-payload-options"
                                                >
                                                    <span
                                                        class="sw-order-line-items-grid__item-label"
                                                    >
                                                        {{ item.label }}
                                                    </span>
                                                </template>
                                            </div>
                                        </template>

                                        <template
                                            #column-quantity="{ item }"
                                        >
                                            <span>
                                                {{ item.quantity }} x
                                            </span>
                                        </template>

                                        <template
                                            #column-price.unitPrice="{ item }"
                                        >
                                            <span>
                                                {{ currencyFilter(item.price.unitPrice,  currency.isoCode) }}
                                            </span>
                                        </template>

                                        <template
                                            #column-price.totalPrice="{ item }"
                                        >
                                            <span>
                                                {{ currencyFilter(item.price.totalPrice,  currency.isoCode) }}
                                            </span>
                                        </template>
                                    </sw-data-grid>

                                    <sw-card-section
                                        divider="top"
                                        slim
                                    >
                                        <sw-description-list
                                            class="sw-order-detail__summary"
                                            grid="1fr 1fr"
                                        >
                                            <template>
                                                <dt>
                                                    {{ $t('sw-order.detailBase.summaryLabelAmount') }}
                                                </dt>

                                                <dd>
                                                    {{ currencyFilter(detailCart.price.positionPrice,  currency.isoCode) }}
                                                </dd>
                                            </template>

                                            <template>
                                                <dt>
                                                    <strong>
                                                        {{ $t('sw-order.detailBase.summaryLabelAmountWithoutTaxes') }}
                                                    </strong>
                                                </dt>

                                                <dd>
                                                    <strong>
                                                        {{ currencyFilter(detailCart.price.netPrice,  currency.isoCode) }}
                                                    </strong>
                                                </dd>
                                            </template>

                                            <template>
                                                <dt>
                                                    <strong>
                                                        {{ $t('sw-order.detailBase.summaryLabelAmountTotal') }}
                                                    </strong>
                                                </dt>

                                                <dd>
                                                    <strong>
                                                        {{ currencyFilter(detailCart.price.totalPrice,  currency.isoCode) }}
                                                    </strong>
                                                </dd>
                                            </template>
                                        </sw-description-list>
                                    </sw-card-section>
                                </template>

                                <mt-banner
                                    v-else
                                    variant="info"
                                >
                                    {{ $t('neti-incomplete-order-reminder.list.modal.loadingCartError') }}
                                </mt-banner>

                                <template #modal-footer>
                                    <mt-button
                                        variant="secondary"
                                        @click="onCloseCartModal"
                                        size="small"
                                    >
                                        {{ $t('neti-incomplete-order-reminder.list.modal.buttonClose') }}
                                    </mt-button>
                                </template>
                            </sw-modal>
                        </template>

                        <template #pagination>
                            <sw-pagination
                                :page="page"
                                :limit="limit"
                                :total="total"
                                :total-visible="7"
                                @page-change="onPageChange"
                            ></sw-pagination>
                        </template>
                    </neti-ior-cart-listing>

                    <sw-empty-state
                        v-if="!isLoading && !total"
                        :title="$t('neti-incomplete-order-reminder.list.messageEmpty')"
                    ></sw-empty-state>
                </div>
            {% endblock %}
        </template>

        <template #sidebar>
            {% block incomplete_order_reminder_open_carts_side_bar %}
                <sw-sidebar>
                    <sw-sidebar-item
                        icon="regular-undo"
                        :title="$t('neti-incomplete-order-reminder.list.refreshButton')"
                        @click="getList"
                    >
                    </sw-sidebar-item>

                    <neti-ior-cart-sidebar-filter @change="onFilterChanged"></neti-ior-cart-sidebar-filter>
                </sw-sidebar>
            {% endblock %}
        </template>
    </sw-page>
{% endblock %}